import { createAction } from "@reduxjs/toolkit";

const showModalFooter = createAction('modalFooter/showModal');

export default showModalFooter;

